<template>
  <div class="post-page-container">
   <div><img src="@/assets/images/head.png" class="bx-head"></div>
    <div class="bx-fw">
        <img src="@/assets/images/ljgp.png" class="bx-fw-img">
        <div class="bx-fw-name">
            <div class="name-s">班车预约</div>
        </div>

        <div @click="tabBuy" class="bx-fw-ok">立即购票</div>
    </div>
	<div class="bx-fw-bp">
	    <img src="@/assets/images/ljgp.png" class="bx-fw-img">
	    <div class="bx-fw-name bx-fw-name1">
	        <div class="name-s">自主补票</div>
	        <!-- <div class="name-sm">注：未预约乘车时使用</div> -->
	    </div>
	    <div @click="tabBuyRepair" class="bx-fw-ok">立即购票</div>
	</div>

    <div class="bx-jd">
         <div class="bx-wx-left"  @click="bctime">
             <img src="@/assets/images/bcxx.png" class="bx-wx-img">
             <div class="bx-wx-name">
                 <div class="name-s">班车信息</div>
                 <div class="name-x">班车车次查询</div>
             </div>
         </div>

        <div class="bx-wx-right" @click="announcement" >
            <img src="@/assets/images/tzgg.png" class="bx-wx-img" >
            <div class="bx-wx-name">
                <div class="name-s">通知公告</div>
                <div class="name-x">最新公告</div>
            </div>
        </div>
       <div style="height:21px;clear:both"></div>
        <div class="bx-wx-left" @click="myorder">
             <img src="@/assets/images/wddd.png" class="bx-wx-img">
             <div class="bx-wx-name">
                 <div class="name-s">我的订单</div>
                 <div class="name-x">订单查询</div>
             </div>
         </div>

        <div class="bx-wx-right"  @click="balance">
            <img src="@/assets/images/bcqb.png" class="bx-wx-img" >
            <div class="bx-wx-name">
                <div class="name-s">班车钱包</div>
                <div class="name-x">我的钱包</div>
            </div>
        </div>
        <div style="clear:both"></div>
    </div>
    <div class="bx-title">我要乘车——最近订单</div>
    <div class="list-wrapper tabbar-bottom-area pulldown-list">
              <order-card v-for="(item,index) in list"
                          :key="index"
                          :list="item"
                          :type="type"/>
              <van-empty image="default" description="没有车次" v-if="list.length === 0" />
    </div>
     <div class="bx-title">服务流程</div>

    <div class="bx-lc">
       <div class="bx-lc-d">
           <img src="@/assets/images/fw1.png" class="lc-img">
           <span class="title">班车预约</span>
       </div>
        <div class="bx-xt">
            <img src="@/assets/images/xt.png" class="bx-xt-img">
        </div>

        <div class="bx-lc-d" style="padding-left: 0px;padding-top: 30px;">
            <img src="@/assets/images/fw2.png" class="lc-img">
            <span class="title" style="margin-top: 8px;">班车购票</span>
        </div>
        <div class="bx-xt">
            <img src="@/assets/images/xt.png" class="bx-xt-img">
        </div>

        <div class="bx-lc-d" style="padding-left: 0px">
            <img src="@/assets/images/fw3.png" class="lc-img">
            <span class="title" style="margin-top: 5px;">候车</span>
        </div>
        <div class="bx-xt">
            <img src="@/assets/images/xt.png" class="bx-xt-img">
        </div>

        <div class="bx-lc-d" style="padding-left: 0px;">
            <img src="@/assets/images/fw4.png" class="lc-img">
            <span class="title"style="margin-top: 7px">乘车验票</span>
        </div>
        <div class="bx-xt">
           <img src="@/assets/images/xt.png" class="bx-xt-img">
        </div>

        <div class="bx-lc-d" style="padding-left: 0px;padding-top: 25px;">
            <img src="@/assets/images/fw5.png" class="lc-img">
            <span class="title">乘车</span>
        </div>

    </div>
    <div class="bx-title">联系我们</div>
    <div class="bx-lc">
        <img src="@/assets/images/mobile.png" class="lx-img">
        <div class="lx-name">
           <div class="name-s">客运服务咨询：13671180316</div>
            <div class="name-x">彩虹巴士预约咨询：13910813193</div>
<!--            <div class="name-x">技术咨询：81383198</div>-->

        </div>
    </div>
    <div style="height: 30px"></div>


    <div class="auth-mask" v-if="showAuth">
      <div class="auth-dialog">
        <!-- 顶部图标+标题 -->
        <div class="dialog-header">
          <div class="icon-box">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#398858" stroke-width="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
          </div>
          <h3 class="title">授权登录</h3>
          <p class="desc">需要获取统一身份认证完成班车系统登录</p>
        </div>

        <!-- 按钮区域 -->
        <div class="btn-group">
          <button class="btn-auth" @click="goDingAuth">立即授权登录</button>
        </div>
      </div>
    </div>
  </div>


</template>

<script>

import { Dialog } from 'vant';
import Order from '@/apis/Order';
import OrderCard from '@/components/order/OrderCard';
import Auth from '@/apis/Auth';
export default {
  name: 'Dating',
  components: {
    OrderCard,
  },
  data() {
    return {
        list: [],
        type: 'paid,expired,evaluation',
        showAuth:false,
        authCode:''
    };
  },
  created(){
    //2026-06-06修改
    this.authCode =this.$route.query?.code || ''
  },
  mounted() {
    //2026-06-06修改
    if(this.authCode !==''){
         //走登录
      Auth.authLogin(this.authCode).then((res) => {

              if (res.code === '1') {
                this.$storage.setStorageSync('setUserid',res?.data.userid || '');
                this.$store.commit('auth/setUserInfo', res?.data);
                this.$storage.setStorageSync('isOneLogin',1)
                this.fetchList();
              }
            }).catch((err) => {

            });

    }else{
      if(!this.$storage.getStorageSync('isOneLogin')){
        this.showAuth =true
      }else{
        let userid = this.$storage.getStorageSync('setUserid')

        if(!userid){
          this.showAuth =true

        }else{
          this.fetchList();
        }
      }

    }



  },

  methods: {
    goDingAuth(){

      window.location.href=process.env.VUE_APP_OAUTH_URL;
    },
     getHomeUrl() {
  // 协议 + 域名  如：https://xxx.com
  const origin = window.location.origin
  // 项目部署的子目录（如果有的话）
  const path = window.location.pathname
  return origin + path
    },
     tabBuy() {
      this.$router.push({
        path: '/home',

      });
    },
	tabBuyRepair(){
		Dialog.confirm({
			title:'自主补票',
		  message: '请先询问司机后购买，购买后不可退款。',
		  confirmButtonText: '立即补票',
		  cancelButtonText: '关闭'
		})
		  .then(() => {
			  this.$router.push({
			    path: '/homerepair',
			  });
		  })
		  .catch(() => {
			  // console.log('2');
		  });

	},
    bctime(){
 this.$router.push({
        path: '/bctime',

      });
    },

announcement() {
      this.$router.push({
        path: '/announcement'
      });
    },

myorder() {
      this.$router.push({
        path: '/orderList'
      });
    },
balance() {
      this.$router.push({
        path: '/balance'
      });
    },
    async fetchList() {
      const params = {
        page:1,
        limit:2,
        ride_date: '',
        status: 'paid,expired,evaluation',
      };
      console.log('列表参数》》》', params);
      const res = await Order.getList(params);
      if (Number(res.code) === 0) {
        this.list = res?.data;
      }
    },
  },
};
</script>

<style lang="scss" scoped>


.bx-head{
    width: 100%;
    height:200px;
}
.bx-fw-bp{
	margin: 0px 15px 0px 15px;
	height: 86px;
	background-color: #F5FBF6;
	position: relative;
	border-radius: 4px;
}
.bx-fw-bp .bx-fw-img{
    width: 42px;
    height: 39px;
    margin: 23px;
    float: left;
}
.bx-fw-bp .bx-fw-name{
    margin-left: 26px;
    width: 65px;
    float: left;
    margin-top: 30px;
}
.bx-fw-name1{
	margin-left: 26px;
	width:auto !important;
	float: left;
	margin-top: 30px;
}
.bx-fw-bp .bx-fw-name .name-s{
    font-size: 16px;
    font-weight: bold;
    color:#101010;
}
.bx-fw-bp .bx-fw-name .name-sm{
    font-size: 12px;
    color:red;
	margin-top: 6px;
}
.bx-fw-bp .bx-fw-name .name-x{
    font-size: 13px;
    color: #959595;
}
.bx-fw-bp .bx-fw-ok{
    color: #5F9B7C;
    border: 1px solid #5F9B7C;
    border-radius: 4px;
    font-size: 14px;
    width: 72px;
    height: 28px;
    float: right;
    margin: 29px 20px 0 0;
    text-align: center;
    line-height: 28px;
}


.bx-fw{
    margin: -30px 15px 0px 15px;
    height: 86px;
    background-color: #F5FBF6;
    position: relative;
    border-radius: 4px;
}
.bx-fw .bx-fw-img{
    width: 42px;
    height: 39px;
    margin: 23px;
    float: left;
}
.bx-fw .bx-fw-name{
    margin-left: 26px;
    width: 65px;
    float: left;
    margin-top: 30px;
}
.bx-fw .bx-fw-name .name-s{
    font-size: 16px;
    font-weight: bold;
    color:#101010;
}
.bx-fw .bx-fw-name .name-x{
    font-size: 13px;
    color: #959595;
}
.bx-fw .bx-fw-ok{
    color: #5F9B7C;
    border: 1px solid #5F9B7C;
    border-radius: 4px;
    font-size: 14px;
    width: 72px;
    height: 28px;
    float: right;
    margin: 29px 20px 0 0;
    text-align: center;
    line-height: 28px;
}
.bx-jd{
     margin: 21px 18px;
}
.bx-jd .bx-wx-left{
   width: 162px;
    height: 84px;
    background-color: #F5FBF6;
    border-radius: 4px;
    float: left;
}
.bx-jd .bx-wx-left .bx-wx-img{
   margin-left: 18px;
   width: 36px;
    height: 40px;
    margin-top: 26px;
    float: left;
}
.bx-jd .bx-wx-left .bx-wx-name{
    margin-left: 19px;

    float: left;
    margin-top: 23px;
}

.bx-jd .bx-wx-left .bx-wx-name .name-s{
    font-size: 16px;
    font-weight: bold;
}
.bx-jd .bx-wx-left .bx-wx-name .name-x{
    font-size: 13px;
    color: #959595;
}


.bx-jd .bx-wx-right{
    width: 162px;
    height: 84px;
    background-color: #F5FBF6;
    border-radius: 4px;
    float: right;
}
.bx-jd .bx-wx-right .bx-wx-img{
    margin-left: 18px;
    width: 42px;
    height: 42px;
    margin-top: 26px;
    float: left;
}
.bx-jd .bx-wx-right .bx-wx-name{
    margin-left: 19px;
    float: left;
    margin-top: 23px;
}

.bx-jd .bx-wx-right .bx-wx-name .name-s{
    font-size: 16px;
    font-weight: bold;
}
.bx-jd .bx-wx-right .bx-wx-name .name-x{
    font-size: 13px;
    color: #959595;
}
.bx-title{
    margin: 21px 18px;
    font-size: 18px;
   font-weight: bold;
}

.bx-lc{
    margin: 0px 18px;
    height: 100px;
    border-radius: 4px;
    background-color: #F5FBF6;

}
.bx-lc .bx-lc-d{
    text-align: center;
     padding-top: 23px;
    padding-left: 15px;
    float: left;
}
.bx-lc .bx-lc-d .lc-img{
    max-width: 100%;
}
.bx-lc .bx-lc-d .title{
    display: block;
    font-size: 12px;
    color: rgba(87, 85, 85, 100);
    margin-top: 7px;
}
.bx-xt{
    padding-top: 30px;
    float: left;
}
.bx-xt .bx-xt-img{
    max-width: 100%;
}
.lx-img{
     margin: 38px 20px;
    float: left;
}
.lx-name{
    float: left;
    margin: 10px 0px 0 0;

}
.lx-name .name-s{
    font-size: 16px;
    color: #959595;
     font-size:16px;
}
.lx-name .name-x{
    font-size: 16px;
    color: #959595;
    padding-top: 10px;
}
//=====================


/* 匹配原图绿色色系 */
.auth-mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.auth-dialog {
  width: 82%;
  max-width: 380px;
  background: #f8fcf9;
  border-radius: 12px;
  overflow: hidden;
}
.dialog-header {
  padding: 32px 24px 20px;
  text-align: center;
}
.icon-box {
  margin: 0 auto 12px;
}
.title {
  font-size: 19px;
  color: #333333;
  margin:0 0 8px;
}
.desc {
  font-size:14px;
  color:#70887c;
  margin:0;
}
.btn-group {
  display:flex;
  border-top:1px solid #ddebe3;
}
.btn-cancel {
  flex:1;
  height:50px;
  border:none;
  background:transparent;
  font-size:15px;
  color:#666;
  border-right:1px solid #ddebe3;
}
.btn-auth {
  flex:1;
  height:50px;
  border:none;
  background:#398858;
  color:#fff;
  font-size:15px;
}

</style>
